/* device.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M1.5,12.7c2.6,3.6,7.6,4.4,11.2,1.8c3.6-2.6,4.4-7.6,1.8-11.2S6.9-1.1,3.3,1.5C-0.3,4.1-1.1,9.1,1.5,12.7z
                 M1.8,12.5l2.6-4.3l0.3,1.3l1.5-1.1c0.3-0.2,0.8-0.2,1,0.2c0.2,0.3,0.2,0.8-0.2,1l-1.5,1.1l1.1,0.7L1.8,12.5z M12.3,12.7
                c0.2,0.3,0.2,0.8-0.2,1s-0.8,0.2-1-0.2L10,12.1l-0.7,1.1L8.2,8.3l4.3,2.6l-1.3,0.3L12.3,12.7z M14.2,3.5l-2.6,4.3l-0.3-1.3L9.8,7.6
                C9.5,7.9,9,7.8,8.8,7.4s-0.2-0.8,0.2-1l1.5-1.1L9.3,4.6L14.2,3.5z M4.9,2.4L6,3.9l0.7-1.1l1.1,4.9L3.5,5.1l1.3-0.3L3.7,3.3
                C3.5,3,3.5,2.5,3.9,2.3S4.7,2.1,4.9,2.4z"/>
            </svg>
         `
};
